import api from '../utils/api';
import apiEndpoints from "../config/apiEndpoints";

const authService = {
    challenge: async (phoneNumber, abortController) => {
        await api.post(apiEndpoints.challenge, {
            PhoneNumber: phoneNumber,
            CreateNew: false,
          }, abortController);
    },
    confirmChallenge: async(phoneNumber, otp, iin, abortController) => {
        return await api.post(apiEndpoints.confirm, {
            PhoneNumber: phoneNumber,
            ChallengeAnswer: otp,
            IIN: iin
          }, abortController);
    },
    refresh: async(refreshToken, userSub) => {
        return await api.post(apiEndpoints.refresh, {
            refreshToken,
            userSub,
        })
    },
    logout: async() => {
        return await api.get(apiEndpoints.logout)
    }
}

export default authService;